class Tabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabButtonElems = this.querySelectorAll(
      'tab-button, button[data-tab-index]'
    );
    this.tabContentElems = this.querySelectorAll(
      'tab-content, [data-tab-panel]'
    );

    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.addButtonEventListeners();
        }
      }
    });

    observer.observe(this);
  }

  addButtonEventListeners() {
    for (const buttonElement of this.tabButtonElems) {
      buttonElement.addEventListener('click', event => {
        if (event.target.active) {
          return;
        }

        for (const buttonElement_ of this.tabButtonElems) {
          buttonElement_.removeAttribute('active');
        }

        buttonElement.setAttribute('active', '');

        const selectedTabContent = this.querySelector(
          `tab-content[data-tab-index="${buttonElement.dataset.tabIndex}"], [data-tab-panel="${buttonElement.dataset.tabIndex}"]`
        );

        selectedTabContent.setAttribute('active', '');
        selectedTabContent.setAttribute('aria-hidden', 'false');

        for (const tabContentElement of this.tabContentElems) {
          if (tabContentElement !== selectedTabContent) {
            tabContentElement.removeAttribute('active');
            tabContentElement.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }
  }
}

export default Tabs;
